import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { NotificationType, User } from '@app/shared/interfaces';
import { LockPayload, SmartlocksService } from '@app/shared/services/smartlocks/smartlocks.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { IntegrationType, resolveIntegrationInfo } from '@app/shared/utils';
import { DialogEditSmartlockComponent } from '../../components/dialog-edit-smartlock/dialog-edit-smartlock.component';

@Component({
  standalone: false,
  selector: 'sbnb-smartlock-success',
  templateUrl: './smartlock-success.component.html',
  styleUrls: ['./smartlock-success.component.scss'],
})
export class SmartlockSuccessComponent implements OnInit {
  learnMoreUrl = `https://www.notion.so/smartbnb/RemoteLocks-integration-3c21ff5d7a414e66b3e3874362d3786e`;
  loading: boolean;
  migrateToSeam: boolean;

  saveStatus: number;
  integration_id: string = '';
  connection_id: any;
  locks: any;
  locksFound: boolean;
  hasUpdatedConnections: boolean = false;
  connectionParam: string | null;

  integration: IntegrationType | null = null;
  user: User;

  constructor(
    private readonly dialog: MatDialog,
    private readonly smartlocksService: SmartlocksService,
    private toast: ToastNotificationsService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly auth: AuthenticationService
  ) { }

  ngOnInit() {
    this.loading = true;

    const integrationData = resolveIntegrationInfo(this.router.url);

    if (integrationData) {
      this.integration_id = integrationData.integration_id;
      this.integration = integrationData.integration as IntegrationType;
    }

    this.route.queryParams.subscribe((res) => {
      this.connectionParam = res.connectionParam;
    });

    this.connectionSuccess();
  }

  connectionSuccess() {
    const payload: LockPayload = {
      integration_id: this.integration_id,
      code: this.connectionParam,
    };

    this.smartlocksService.connectionSuccess(payload).subscribe((res) => {
      if (res.errors) {
        this.toast.open(Object.values(res.errors)[0] as string, 'Dismiss', NotificationType.Error);
        return;
      }

      this.connection_id = res.connection_id;

      this.getAllLocks();
    });
  }

  getAllLocks() {
    const payload = {
      integration_id: this.integration_id,
      connection_id: this.connection_id,
    };

    this.smartlocksService.getAllConnectionLocks(payload).subscribe((res) => {
      if ('errors' in res) {
        this.toast.open(Object.values(res.errors)[0] as string, 'Dismiss', NotificationType.Error);
        return;
      }

      this.loading = false;
      this.locks = res.locks;
      this.hasUpdatedConnections = res.has_updated_connections;
      if (this.locks.length > 0) {
        this.locksFound = true;
      } else {
        this.locksFound = false;
      }
    });
  }

  matchLocks() {
    const dialogRef = this.dialog.open(DialogEditSmartlockComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      disableClose: true,
      data: {
        integration_id: this.integration_id,
        connection_id: this.connection_id,
        lock: this.locks[0],
        locks: this.locks,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // redirect to Schlage locks page
      this.redirectToLocksPage();
    });
  }

  redirectToLocksPage() {
    this.router.navigate(['/apps/' + this.integration.toLowerCase()]).then(() => {
      window.location.reload(); // Reload the page to refetch all locks
    });
  }

  retryFetchingAllLocks() {
    this.loading = true;
    this.locksFound = null;
    this.connectionSuccess();
  }
}
